import React from "react";
import { useTranslation } from "../../i18n/LanguageContext";
const CookiePolicy = () => {
   const { t } = useTranslation();
   return (
      <div className="kap-policy d-flex flex-column" style={{ gap: "16px" }}>
         <p className="kap-policy__title">
            {t("cookie-policy-tab-label")}
         </p>
         <div className="d-flex flex-column" style={{ gap: "30px" }}>
            <div className="d-flex flex-column">
               <p className="mb-6">{t("cookie-last-updated-text")}</p>
               <p>
                  {t("cookie-intro-websites-prefix-text")}{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.i-aps.com"}
                     className="kap-policy__link"
                  >
                     https://www.i-aps.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kaptechgroup.com"}
                     className="kap-policy__link"
                  >
                     https://kaptechgroup.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kapsurvey.com"}
                     className="kap-policy__link"
                  >
                     https://www.kapsurvey.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kaporg.com"}
                     className="kap-policy__link"
                  >
                     https://www.kaporg.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapinsights.com"}
                     className="kap-policy__link"
                  >
                     https://kapinsights.com
                  </a>{" "}
                  and{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapcourse.com"}
                     className="kap-policy__link"
                  >
                     https://kapcourse.com
                  </a>
                  {t("cookie-intro-websites-suffix-text")}
               </p>
               <p>{t("cookie-third-party-services-notice-text")}</p>
               <p>
                  {t("cookie-refuse-prefix-text")}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.i-aps.com"}
                     className="kap-policy__link"
                  >
                     https://www.i-aps.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kaptechgroup.com"}
                     className="kap-policy__link"
                  >
                     https://kaptechgroup.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kapsurvey.com"}
                     className="kap-policy__link"
                  >
                     https://www.kapsurvey.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kaporg.com"}
                     className="kap-policy__link"
                  >
                     https://www.kaporg.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapinsights.com"}
                     className="kap-policy__link"
                  >
                     https://kapinsights.com
                  </a>{" "}
                  and{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapcourse.com"}
                     className="kap-policy__link"
                  >
                     https://kapcourse.com
                  </a>
                  {t("cookie-refuse-suffix-text")}
               </p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("what-is-a-cookie-title")}
               </h4>
               <p>{t("cookie-definition-text")}</p>
               <p>{t("cookie-usage-examples-text")}</p>
               <p>{t("first-party-cookies-definition-text")}</p>
               <p>{t("third-party-cookies-definition-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("cookie-types-title")}
               </h4>
               <p>{t("essential-cookies-definition-text")}</p>
               <p>{t("essential-cookies-usage-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("performance-cookies-title")}
               </h4>
               <p>{t("performance-cookies-definition-text")}</p>
               <p>{t("performance-cookies-usage-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("functionality-cookies-title")}
               </h4>
               <p>{t("functionality-cookies-definition-text")}</p>
               <p>{t("functionality-cookies-usage-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("targeting-advertising-cookies-title")}
               </h4>
               <p>{t("targeting-advertising-cookies-definition-text")}</p>
               <p>{t("targeting-advertising-cookies-usage-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("control-cookies-title")}
               </h4>
               <p>{t("cookie-consent-manager-description-text")}</p>
               <p>{t("browser-settings-cookie-control-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("cookie-policy-update-frequency-title")}
               </h4>
               <p>{t("cookie-policy-update-reason-text")}</p>
               <p>{t("cookie-policy-version-notice-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("cookie-policy-further-info-title")}
               </h4>
               <p>{t("cookie-policy-contact-us-description-text")}</p>
               <p className="kap-policy__subheading">
                  {t("customer-service-label")}
               </p>
               <a href="mailto:info@kaptechgroup.com" className="kap-policy__link">
                  info@kaptechgroup.com
               </a>
            </div>
         </div>
      </div>
   );
};

export default CookiePolicy;
